// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class SvgIconService {

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
  ) {
  }

  addSvgIconsToRegistry(): void {
    const icons = [
      'checkbox_square_checked',
      'checkbox_square_outlined',
    ];
    icons.forEach(icon => {
      const url = this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${ icon }.svg`);
      this.matIconRegistry.addSvgIcon(icon, url);
    });
  }
}
